// Modules
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
// Style
import style from "./ForgetPassword.module.css";
import { onForgetPass } from "../../../Services/usersService";

const ForgetPassword = () => {
  const history = useHistory();
  const [email, setEmail] = useState();
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleSend = (e) => {
    e.preventDefault();
    toast.promise(onForgetPass({ email }), {
      loading: "درحال ارسال ایمیل . . .",
      success: (res) => {
        setTimeout(() => {
          history.push("/");
        }, 1000);
        return res.data.message;
      },
      error: (err) => err.response.data.message,
    });
  };
  return (
    <div className={style.container}>
      <Toaster />
      <div className={style.mainContainer}>
        <h2>فراموشی رمز عبور</h2>
        <div className={style.forgetpassInput}>
          <input onChange={handleEmail} type="email" placeholder="ایمیل" />
          <button className={style.button} onClick={handleSend}>
            ثبت
          </button>
        </div>
        <Link to="/" className={style.backHome}>
          صفحه اصلی
        </Link>
      </div>
    </div>
  );
};

export default ForgetPassword;
